import { render } from "./ModalDocumentos.vue?vue&type=template&id=0e547956&scoped=true"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js"

import "./ModalDocumentos.vue?vue&type=style&index=0&id=0e547956&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e547956"]])

export default __exports__